export enum FilterOperations {
    Equals = "eq",
    NotEquals = "neq",
    GreaterThan = "gt",
    LessThan = "lt",
    GreaterThanOrEqual = "gte",
    LessThanOrEqual = "lte",
    Contains = "in",
    NotContains = "not_in",
    StartsWith = "sw",
    EndsWith = "ew"
}

export class FilterValue {
    propertyName?: string;
    values: any[] = [];
    operator?: FilterOperations;
    hasAnd: boolean = false;

    constructor(init?: Partial<FilterValue>) {
        Object.assign(this, init);
    }
}

export enum OrderTypes {
    Asc = "asc",
    Desc = "desc"
}

export class OrderValue {
    propertyName?: string;
    type: OrderTypes = OrderTypes.Asc;
    index: number = 0;

    constructor(init?: Partial<OrderValue>) {
        Object.assign(this, init);
    }
}

export class FilterRequest {
    private _page: number = 1;
    private _limit: number = 10;
    
    get page(): number {
        return this._page;
    }
    set page(value: number) {
        this._page = Math.max(1, value);
    }

    get limit(): number {
        return this._limit;
    }
    set limit(value: number) {
        this._limit = Math.max(1, value);
    }

    isFull: boolean = false;
    keyword?: string;
    filters: FilterValue[] = [];
    orders: OrderValue[] = [];
    summary?: string;
    tree: boolean = false;

    constructor(init?: Partial<FilterRequest>) {
        Object.assign(this, init);
    }
}

export class FilterResult<T> {
    private _page: number = 1;
    private _limit: number = 10;

    get page(): number {
        return this._page;
    }
    set page(value: number) {
        this._page = Math.max(1, value);
    }

    get limit(): number {
        return this._limit;
    }
    set limit(value: number) {
        this._limit = Math.max(1, value);
    }

    isFull: boolean = false;
    totalPages?: number;
    list: T[] = [];
    totalRecords: number = 0;
    summary: Record<string, any> = {};
    tree: boolean = false;

    constructor(init?: Partial<FilterResult<T>>) {
        Object.assign(this, init);
    }
}
